export default "__VITE_ASSET__CbfV_lBs__"